'use strict';exports.__esModule = true;exports.default = beautifyNumber;function beautifyNumber(str) {
  if (!str) {
    return '';
  }
  return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/beautifyNumber.js
// module id = 27
// module chunks = 0